import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const TRUSTED_PARTNERS_LABEL = { tr: 'Güvenilir Partnerlerimiz', en: 'Trusted Partners' };
const CTA_BASE = 'w-full py-1 sm:py-1.5 md:py-2 rounded-full text-center text-[7px] sm:text-[9px] md:text-[11px] text-white';

const MockupBadge = () => (
  <div className="inline-flex self-start items-center gap-1 px-1.5 sm:px-2 md:px-2.5 py-0.5 sm:py-1 rounded-full bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-blue-500/30 mb-2 sm:mb-3">
    <span className="text-[5px] sm:text-[7px] md:text-[9px] text-orange-300">✦</span>
    <span className="text-[6px] sm:text-[8px] md:text-[10px] font-semibold text-blue-200 tracking-wide">
      MRK Digital Consultancy
    </span>
  </div>
);

export const MockupHero = () => {
  const { t, language } = useLanguage();

  return (
    <div className="absolute inset-0 flex flex-col justify-center px-3 sm:px-4 md:px-5 pt-10 sm:pt-12 md:pt-16 pb-3">
      <MockupBadge />
      <h4 className="text-[10px] sm:text-sm md:text-lg font-bold text-white leading-tight mb-1 sm:mb-1.5 md:mb-2">
        {t.hero.title}
      </h4>
      <p className="text-[6px] sm:text-[9px] md:text-[11px] text-gray-300 leading-snug mb-1 sm:mb-1.5 line-clamp-2">
        {t.hero.subtitle}
      </p>
      <p className="text-[5px] sm:text-[8px] md:text-[10px] text-gray-400 leading-snug mb-2 sm:mb-3 line-clamp-2">
        {t.hero.description}
      </p>
      <div className="flex flex-col gap-1 sm:gap-1.5 md:gap-2">
        <div className={`${CTA_BASE} bg-gradient-to-r from-orange-500 to-orange-600 font-bold shadow-md shadow-orange-500/30`}>
          {t.hero.cta}
        </div>
        <div className={`${CTA_BASE} bg-white/10 border border-white/20 font-semibold`}>
          {TRUSTED_PARTNERS_LABEL[language] || TRUSTED_PARTNERS_LABEL.en}
        </div>
      </div>
      <img
        src="/rocket.png"
        alt=""
        aria-hidden="true"
        className="absolute right-1 sm:right-2 md:right-3 bottom-1 sm:bottom-2 w-10 sm:w-14 md:w-20 opacity-90 pointer-events-none"
      />
    </div>
  );
};
